import { NotificationTypeDto } from './notification-type.dto';
import { UserDto } from './user.dto';
import { FeedReactionKindsEnum, NotificationTypesEnum } from '../../enums';
import { UserToFollowerDto } from './user-to-follower.dto';
import { EventToUserDto } from './event-to-user.dto';
import { UsersRelationFlags } from '../../interfaces/users';
import { ListWithTotals } from './list-with.totals';
import { InterestDto } from './interest.dto';
import { UserToPastEventDto, PastEventDto } from './past-event.dto';
import { StreamChatRequestDto } from './stream-chat-request.dto';
import { ReactionDto } from './feed.dto';
import { ArrayNotEmpty, IsArray, IsBoolean, IsNotEmpty, IsString, ValidateIf } from 'class-validator';
import { ChallengeDto, ChallengeWeekDto, EventDto, MembershipDto, UpdateEventNotificationReason } from '.';

export class NotificationDto {
	public id: string;
	public receiverId: string;
	public causeUserId?: string;
	public causeEntityId?: string;
	public typeId: NotificationTypesEnum;
	public additionalData?: NotificationAdditionalDataDto;
	public isPostPopupHasBeenShown?: boolean;

	public readAt?: Date;
	public createdAt: Date;
	public updatedAt?: Date;
	public receiver?: UserDto;
	public causeUser?: UserDto;
	public type?: NotificationTypeDto;
	public userToFollower?: UserToFollowerDto;
	public event?: EventDto;
	public eventToUser?: EventToUserDto;
	public interest?: InterestDto;
	public userToPastEvent?: UserToPastEventDto;
	public pastEvent?: PastEventDto;
	public streamChatRequest?: StreamChatRequestDto;
	public user?: UserDto;
	public reaction?: ReactionDto;
	public membership?: MembershipDto;
	public challenge?: ChallengeDto;
	public challengeWeek?: ChallengeWeekDto;

	public userToFollowerRelations?: UsersRelationFlags;

	public message?: string;
}

export class NotificationAdditionalDataDto {
	public title?: string;
	public content?: string;

	public eventInstance?: string | Date;
	public donationAmount?: number;

	public eventTicketId?: string;

	public tierName?: string;

	public kind?: FeedReactionKindsEnum;
	public activityId?: string;
	public feedUserId?: string;
	public commentId?: string;

	public mentionedUserIds?: string[];

	public isPostCreated?: boolean;
	public isPostPopupHasBeenShown?: boolean;

	public challengeName?: string;
	public challengeAlias?: string;

	public eventUpdateReasons?: UpdateEventNotificationReason[];
}

export class CreateNotificationDto
	implements Pick<NotificationDto, 'receiverId' | 'causeUserId' | 'causeEntityId' | 'typeId' | 'additionalData' | 'challengeWeek'>
{
	public receiverId: string;
	public causeUserId?: string;
	public causeEntityId?: string;
	public typeId: NotificationTypesEnum;
	public additionalData?: NotificationAdditionalDataDto;
	public challengeWeek?: ChallengeWeekDto;
}

export class NotificationsCountsDto {
	public total: number;
	public unreadTotal: number;
}

export interface NotificationListWithTotalsDto extends ListWithTotals<NotificationDto>, NotificationsCountsDto {}

export class MarkNotificationsAsReadDto {
	@ValidateIf((o) => !o.readAll && !o.readBeforeDate && !o.readAfterDate)
	@IsNotEmpty()
	@IsArray()
	@IsString({ each: true })
	@ArrayNotEmpty()
	public notificationsIds?: string[];

	@ValidateIf((o) => !o.notificationsIds && !o.readBeforeDate && !o.readAfterDate)
	@IsNotEmpty()
	@IsBoolean()
	public readAll?: boolean;

	@ValidateIf((o) => !o.notificationsIds && !o.readAll && !o.readAfterDate)
	@IsNotEmpty()
	public readBeforeDate?: Date;

	@ValidateIf((o) => !o.notificationsIds && !o.readAll && !o.readBeforeDate)
	@IsNotEmpty()
	public readAfterDate?: Date;
}
